import { Pipe, PipeTransform } from '@angular/core';
import { SBTime, TimeFormat } from '../date-time/sb-date-time';

@Pipe({
    name: 'formatTime'
})
export class LocalizationTimePipe implements PipeTransform {

    transform(value: string | null, pattern: TimeFormat) : string {
        if (!value) {
            return '';
        }

        try {
            return SBTime.FromISO(value).Render(pattern).replace(/\s/g, '\u00A0');
        } catch {
            return '';
        }
    }
}
